import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { IPrimaryDealerList } from '@components/onetoonemeetings';
import { ErrorHandler } from '@helper/errorHandler';

export const useDealersListQuery = (): IQueryResponse<IPrimaryDealerList[]> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('dealers_list');

	const fetchDealersList = async (): Promise<IPrimaryDealerList[]> => {
		try {
			const response = await APIService.getData<IPrimaryDealerList[]>(APICONFIG.PRIMARY_DEALERS_LIST, {
				limit: '0',
			});
			if (response) {
				await setRxdb('dealers_list', response);
			}
			return response;
		} catch (error) {
			ErrorHandler(error);
			return [];
		}
	};

	const { data, error, isLoading, isPending, refetch } = useQuery({
		queryKey: ['primaryDealersList'],
		queryFn: fetchDealersList,
		enabled: isDbChecked && shouldFetch,
		retry: false,
		staleTime: 30 * 60 * 1000,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
	};
};
